import { ENV } from "../../config/env";

/**
 * Application Configuration
 * Uses validated environment variables from ENV helper
 */
const CONFIG = {
  API_URL: ENV.API_URL,
  ADMIN_API_URL: ENV.ADMIN_API_URL || `${ENV.API_URL}admin/`,
  URL_KEY_STRING: ENV.URL_KEY_STRING,
};

// const headers = (headers, { getState, endpoints }) => {
//   const { token } = getState()?.userState?.user;
//   headers.set("Authorization", `${token}`);
//   return headers;
// };

export { CONFIG };
